
import { defineComponent } from 'vue';

const ruby: Record<string, string> = {
  a: 'えー',
  A: 'エー',
  b: 'びー',
  B: 'ビー',
  c: 'しー',
  C: 'シー',
  d: 'でぃー',
  D: 'ディー',
  e: 'いー',
  E: 'イー',
  f: 'えふ',
  F: 'エフ',
  g: 'じー',
  G: 'ジー',
  h: 'えいち',
  H: 'エイチ',
  i: 'あい',
  I: 'アイ',
  j: 'じぇい',
  J: 'ジェイ',
  k: 'けー',
  K: 'ケー',
  l: 'える',
  L: 'エル',
  m: 'えむ',
  M: 'エム',
  n: 'えぬ',
  N: 'エヌ',
  o: 'おー',
  O: 'オー',
  p: 'ぴー',
  P: 'ピー',
  q: 'きゅー',
  Q: 'キュー',
  r: 'あーる',
  R: 'アール',
  s: 'えす',
  S: 'エス',
  t: 'てぃー',
  T: 'ティー',
  u: 'ゆー',
  U: 'ユー',
  v: 'ぶい',
  V: 'ブイ',
  w: 'だぶりゅー',
  W: 'ダブリュー',
  x: 'えっくす',
  X: 'エックス',
  y: 'わい',
  Y: 'ワイ',
  z: 'ぜっと',
  Z: 'ゼット',
} as const;

export default defineComponent({
  name: 'RubyText',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const convertRubyText = () => {
      return props.text
        .split('')
        .map((c: string) => (ruby[c] ? ruby[c] : c))
        .join('');
    };

    return {
      convertRubyText,
    };
  },
});
